import React from 'react';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { usePerformanceReportingContext } from '../../../../context/usePerformanceReportingContext';
import { GrossOfFeeIcon } from '../../../GrossOfFeeIcon/GrossOfFeeIcon';
import { usePeriodReturn } from '../../../PeriodReturn/usePeriodReturn';
import { ValueVsInvestmentChart } from '../../../ValueVsInvestmentChart/ValueVsInvestmentChart';
import { StyledCard } from './ValueVsInvestmentCard.style';

interface Props {
  title: string;
}

export const ValueVsInvestmentCard = React.memo(({ title }: Props) => {
  const { updatedAt, selectedItemName } = usePerformanceReportingContext();

  const { data: periodReturnData } = usePeriodReturn();

  const portfolioReturn = periodReturnData?.value ? parseFloat(periodReturnData?.value) : null;

  return (
    <StyledCard>
      <Text variant="cardTitle" mb="12">
        {title}
        <GrossOfFeeIcon />
      </Text>

      <ValueVsInvestmentChart
        title={selectedItemName}
        portfolioReturn={portfolioReturn}
        updatedAt={updatedAt}
      />
    </StyledCard>
  );
});
